
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.5 20.49"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 1"}},[_c('path',{attrs:{"d":"M17.5 4.36c0-.19-.11-.37-.29-.45L8.97.04s-.03 0-.05-.01h-.04a.585.585 0 00-.13-.02c-.04 0-.09 0-.13.02h-.04c-.02 0-.04 0-.05.01L.29 3.9c-.18.09-.29.26-.29.46v8.09c-.02 3.54 4.73 7.38 8.62 8.03h.24c3.9-.66 8.64-4.49 8.62-8.03v-8.1zm-1 8.1c.01 2.77-3.96 6.37-7.75 7.03C4.96 18.83.99 15.23 1 12.46V4.68l7.75-3.63 7.75 3.63v7.78z"}}),_c('path',{attrs:{"d":"M12.04 8.41h-.79V7.04c0-1.22-.99-2.21-2.21-2.21h-.59c-1.22 0-2.21.99-2.21 2.21v1.37h-.79c-.5 0-.92.41-.92.92v4.98c0 .5.41.92.92.92h6.58c.5 0 .92-.41.92-.92V9.33c0-.5-.41-.92-.92-.92zM7.25 7.04c0-.67.54-1.21 1.21-1.21h.59c.67 0 1.21.54 1.21 1.21v1.37h-3V7.04zm4.71 7.18H5.55V9.41h6.41v4.81z"}}),_c('path',{attrs:{"d":"M8.75 11c-.45 0-.82.37-.82.82s.37.82.82.82.82-.37.82-.82S9.2 11 8.75 11z"}})])])
          )
        }
      }
    